import { createStore, combineReducers, applyMiddleware } from "redux";
import thunk from "redux-thunk";
import { composeWithDevTools } from "redux-devtools-extension";
import {
  newProductReducer,
  newReviewReducer,
  productDetailsReducer,
  productReducer,
  productReviewsReducer,
  productsReducer,
  reviewReducer,
} from "./reducers/productReducer";

import {
  allUsersReducer,
  forgotPasswordReducer,
  profileReducer,
  userDetailsReducer,
  userReducer,
} from "./reducers/userReducer";

import { cartReducer } from "./reducers/cartReducer";
import {
  allOrdersReducer,
  myOrdersReducer,
  newOrderReducer,
  orderDetailsReducer,
  orderReducer,
} from "./reducers/orderReducer";

const reducer = combineReducers({
  products: productsReducer,
  productDetails: productDetailsReducer,
  user: userReducer,
  profile: profileReducer,
  forgotPassword: forgotPasswordReducer,
  cart: cartReducer,
  newOrder: newOrderReducer,
  myOrders: myOrdersReducer,
  orderDetails: orderDetailsReducer,
  newReview: newReviewReducer,
  newProduct: newProductReducer,
  product: productReducer,
  allOrders: allOrdersReducer,
  order: orderReducer,
  allUsers: allUsersReducer,
  userDetails: userDetailsReducer,
  productReviews: productReviewsReducer,
  review: reviewReducer,
});

const middleware = [thunk];

const loadState = () => {
  try {
    const serializedState = localStorage.getItem('vastrakala');
    if (serializedState) {
      const state = JSON.parse(serializedState);
      // Ensure selectedCategory has a default value if not present
      if (state.user && !state.user.selectedCategory) {
        state.user.selectedCategory = localStorage.getItem("selectedCategory") || 'Women';
      }
      return state;
    }
    // Return initial state with selectedCategory if no saved state exists
    return {
      cart: { cartItems: [], wishlist: [], shippingInfo: [] },
      user: { 
        user: {}, 
        selectedCategory: localStorage.getItem("selectedCategory") || 'Women' 
      }
    };
  } catch (err) {
    console.error('Error loading state from localStorage', err);
    return {
      cart: { cartItems: [], wishlist: [], shippingInfo: [] },
      user: { 
        user: {}, 
        selectedCategory: localStorage.getItem("selectedCategory") || 'Women' 
      }
    };
  }
};

const saveState = (state) => {
  try {
    const serializedState = JSON.stringify(state);
    localStorage.setItem('vastrakala', serializedState);
  } catch (err) {
    console.error('Error saving state to localStorage', err);
  }
};

const store = createStore(
  reducer,
  loadState(),
  composeWithDevTools(applyMiddleware(...middleware))
);


store.subscribe(() => {
  saveState(store.getState());
});

export default store;
